import { render } from "./IconContainer.vue?vue&type=template&id=23362bf2"
import script from "./IconContainer.vue?vue&type=script&lang=ts"
export * from "./IconContainer.vue?vue&type=script&lang=ts"
script.render = render

export default script